import {isEmpty} from 'lodash';
import {useTranslation} from 'react-i18next';

import {
    DataWrapper,
    Table,
    TableRow,
    TableCell,
    TableHeadCell,
    TableHead,
    TableBody
} from 'components';
import {TRANSLATION_KEYS} from 'locale';
import {OAuthClient} from 'types';

const T_KEYS = TRANSLATION_KEYS.USER.ACCOUNT.SETTINGS.OAUTH;

type Props = {
    loading?: boolean;
    clients: OAuthClient[];
    renderClientId: (clientId: string, labelPlacement?: 'left' | 'right') => JSX.Element;
    renderSecret: (client: OAuthClient) => JSX.Element;
    renderScopes: (client: OAuthClient, labelPlacement?: 'left' | 'right') => JSX.Element;
    renderCreated: (createdAt: Date) => string;
    renderUpdated: (updatedAt: Date) => string;
    renderActions: (client: OAuthClient) => JSX.Element;
};

export const OAuthTable = ({
    loading,
    clients,
    renderClientId,
    renderSecret,
    renderScopes,
    renderCreated,
    renderUpdated,
    renderActions
}: Props) => {
    const {t} = useTranslation();

    return (
        <DataWrapper isLoading={loading} noData={isEmpty(clients)}>
            <Table noData={isEmpty(clients)}>
                <TableHead>
                    <TableRow>
                        <TableHeadCell>{t(T_KEYS.TABLE.NAME)}</TableHeadCell>
                        <TableHeadCell>{t(T_KEYS.TABLE.CLIENT_ID)}</TableHeadCell>
                        <TableHeadCell>{t(T_KEYS.TABLE.CLIENT_SECRET)}</TableHeadCell>
                        <TableHeadCell>{t(T_KEYS.TABLE.SCOPES)}</TableHeadCell>
                        <TableHeadCell>{t(T_KEYS.TABLE.CREATED)}</TableHeadCell>
                        <TableHeadCell>{t(T_KEYS.TABLE.UPDATED)}</TableHeadCell>
                        <TableHeadCell className='tw-text-right'>{t(T_KEYS.TABLE.ACTIONS)}</TableHeadCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {clients.map((client) => (
                        <TableRow key={client.id}>
                            <TableCell>{client.name}</TableCell>
                            <TableCell>{renderClientId(client.clientId)}</TableCell>
                            <TableCell>{renderSecret(client)}</TableCell>
                            <TableCell>{renderScopes(client)}</TableCell>
                            <TableCell>{renderCreated(client.createdAt)}</TableCell>
                            <TableCell>{renderUpdated(client.updatedAt)}</TableCell>
                            <TableCell>{renderActions(client)}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </DataWrapper>
    );
};